<template>
  <div class="page">
    <div class="container">
      <div class="row py-3 d-flex justify-content-center align-items-center ">
        <div class="amount-box col-2">
          <h1 class="amount-paid change-amount">{{ formatMoneyWithSymbol(receipt.paidAmount) }}</h1>
          <h4 class="amount-label">Total Paid</h4>
        </div>
        <div class="amount-box col-2 amount">
          <h1 class="amount-paid change-amount">{{ formatMoneyWithSymbol(receipt.change - receipt.tip) }}</h1>
          <h4 class="amount-label">Cash Change</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mb-3">
          <div class="email-section">
            <label for="emailInput" class="email-label">Send receipt via email (optional)</label>
            <input 
              type="email" 
              id="emailInput"
              v-model="email" 
              class="email-input" 
              placeholder="Enter customer email address"
            />
          </div>
        </div>
        <div class="d-flex justify-content-center fixed-bottom mb-2">
          <button @click="reprintLastInvoice" class="btn btn-primary mx-3 reprint-btn">Reprint</button>
          <button @click="nextSale" class="next-button cent">Next Sale</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Storage } from '@/services/Storage';
export default {
  name: "ViewInvoicesView",
  data() {
    return {
      email: '',
      currecny: ''
    }
  }, computed: {
    receipt() {
      const invoice = this.$store.getters.getLatestInvoice;
      try {
        // Parse the androidprintdata JSON string
        const androidData = JSON.parse(invoice.androidprintdata || '{}');
        // Access currency symbol from the parsed data
        const currencySymbol = androidData.Currency?.Symbol || 'K'; // Default to 'K' if not found
        return {
          ...invoice,
          currencySymbol // Add currencySymbol to the returned object
        };
      } catch (error) {
        console.error('Error parsing androidprintdata:', error);
        // Return a fallback object if parsing fails
        return {
          ...invoice,
          currencySymbol: 'K' // Default to 'K' if parsing fails
        };
      }
    }
  },
  methods: {
    async nextSale() {

      if (this.email && this.isValidEmail(this.email)) {
        console.log('Sending email receipt');
        try {
          await this.sendEmailReceipt();
        } catch (error) {
          console.error('Failed to send email:', error);
          // Continue with next sale even if email fails
        }
      }
      else {
        console.log('No email provided');
      }
      
      return Promise.all([
        this.$store.dispatch(`getAllStock`),
        this.$store.dispatch(`getAllActiveSpecials`),
        this.proceed(),
      ]);
    },
    async sendEmailReceipt() {
      const invoice = this.$store.getters.getLatestInvoice;
      console.log('Invoice:', invoice.invoice);
   

      const emailData = {
        email: this.email,
        inv: invoice.invoice
      };

      try {
        const storeDB = await Storage.getCurrentStoreDB();
        const response = await window.axios.post(
          `${window.franchiseTomcatApi}emailrecord/${storeDB}/emailSale`,
          emailData,
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );
        return response.data;
      } catch (error) {
        throw new Error(`Email send failed: ${error.response?.status || error.message}`);
      }
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    proceed(){
      return this.$store.dispatch('proceedToSales')
    },
    reprintLastInvoice() {
      return this.$store.dispatch(`reprintLastInvoice`);
    },
    formatMoneyWithSymbol(amount) {
      const currencySymbol = this.receipt.currencySymbol || 'K';
      // Custom money formatting
      const formattedAmount = parseFloat(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
      return `${currencySymbol} ${formattedAmount}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background: white;
  height: 100%;
}

.amount-box {
  height: 100px;
  width: 50%;
  display: flex;
  flex-direction: column;

  .amount-label {
    color: #40434A;
  }

  .amount-paid {
    font-size: 2rem;
    padding: 0;
    margin: 0;
    outline: transparent;
    border: none;
    height: 44px;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
  }
}

.amount-box:first-child {
  align-items: end;

  .amount-paid {
    padding-bottom: 9px;
    text-align: right;
    max-width: 250px;
    width: 100%;

    &:focus, &:active {
      border-bottom: 3px solid #9ccc65 !important;
    }
  }
}

.amount-box:nth-child(2) {
  align-items: start;
  border-left: 1px solid #d2d2d2;
}

button {
  width: 100%;
  font-weight: 700;
  height: 60px;
  border-radius: 10px;
  max-width: 500px;
}

.next-button {
  background: #9ccc65;
  color: white;
}

.email-section {
  text-align: center;
  margin-bottom: 20px;
}

.email-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #40434A;
  font-size: 14px;
}

.email-input {
  width: 100%;
  max-width: 400px;
  padding: 12px 16px;
  border: 2px solid #d2d2d2;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #9ccc65;
  }
  
  &::placeholder {
    color: #999;
  }
}
</style>
